<template>
  

<section class="kc-elm kc-css-467371 kc_row">
   <div class="befbgr" data-ssc-svg="11345" data-ssc-img-s="full" data-ssc-img-anim=""><img class=" lazyloaded" data-src="../../assets/images/Curves-1.png" alt="" src="../../assets/images/Curves-1.png"></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-632668 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="kc-elm kc-css-426583 kc_row kc_row_inner sst-flex-row-inner">
                  <div v-for="metric in statics" :key="metric.title" class="kc-elm kc-css-334182 kc_col-sm-3 kc_column_inner kc_col-sm-3">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="css_counter type2   blur kc-elm kc-css-21193 ">
                           <div class="countbox"><span class="pref"></span><span class="num"><span class="counterup">{{metric.number}}</span></span><span class="suf">{{metric.symbol}}</span></div>
                           <div class="lbl">{{metric.title}}</div>
                           <div class="description lines"><br></div>
                        </div>
                     </div>
                  </div>
                  
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "Statics",
  props: ["title", "subtitle", "header", "statics"],
  data() {
    return {
      msg: "Statics"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-3{width:25%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
img{border:0;max-width:100%;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.befbgr img{max-width:100%;height:auto;}
.main [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
body .css_counter{overflow:hidden;position:relative;width:auto;transition:all 400ms;margin:0 auto;float:none;}
.css_counter .countbox{margin:0 auto;display:table;transition:all 300ms;}
.css_counter .countbox>span{display:table-cell;}
.css_counter .description{transition:all 400ms;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
.css_counter .description{display:none!important;}
.css_counter{padding-bottom:0px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-334182{width:25%;}
body.kc-css-system .kc-css-738008{width:25%;}
body.kc-css-system .kc-css-296596{width:25%;}
body.kc-css-system .kc-css-349037{width:25%;}
}
body.kc-css-system .kc-css-467371{text-align:center;padding-top:109px;padding-bottom:57px;}
body.kc-css-system .kc-css-467371 .befbgr:nth-child(1) img{width:2002px;}
body.kc-css-system .kc-css-467371 .befbgr:nth-child(1){text-align:center;}
body.kc-css-system .kc-css-21193{text-align:center;}
body.kc-css-system .kc-css-21193 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-21193 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-21193 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-21193 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
body.kc-css-system .kc-css-21193 .description{display:none!important;}
body.kc-css-system .kc-css-803051{text-align:center;}
body.kc-css-system .kc-css-803051 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-803051 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-803051 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-803051 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
body.kc-css-system .kc-css-91163{text-align:center;}
body.kc-css-system .kc-css-91163 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-91163 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-91163 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-91163 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
body.kc-css-system .kc-css-858258{text-align:center;}
body.kc-css-system .kc-css-858258 .lbl{color:#222222;font-size:20px;line-height:28px;font-weight:600;padding-top:20px;}
body.kc-css-system .kc-css-858258 .countbox{text-align:center;display:table;}
body.kc-css-system .kc-css-858258 .num{color:#222222;font-size:64px;line-height:50px;font-weight:500;font-family:Montserrat;}
body.kc-css-system .kc-css-858258 .suf{color:#ED7D31;font-size:55px;line-height:45px;font-weight:500;vertical-align:middle;}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-21193{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-803051{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-91163{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-858258{padding-bottom:15px;padding-left:0px;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-334182{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-21193{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-738008{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-803051{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-296596{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-91163{padding-bottom:15px;padding-left:0px;}
body.kc-css-system .kc-css-349037{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-858258{padding-bottom:15px;padding-left:0px;}
}
@media only screen and (max-width:767px){
body.kc-css-system .kc-css-467371{padding-top:80px;}
body.kc-css-system .kc-css-21193{padding-top:30px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-803051{padding-top:30px;padding-right:20px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-91163{padding-top:30px;padding-right:20px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-858258{padding-top:30px;padding-right:20px;padding-bottom:30px;border:1px solid rgba(255, 255, 255, 0);}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-21193 .num{font-size:40px;line-height:50px;}
body.kc-css-system .kc-css-803051 .num{font-size:40px;line-height:50px;}
body.kc-css-system .kc-css-91163 .num{font-size:40px;line-height:50px;}
body.kc-css-system .kc-css-858258 .num{font-size:40px;line-height:50px;}
}

</style>



// WEBPACK FOOTER //
// src/components/Blocks/Statics.vue